import LocalStorage from '@/utils/LocalStorage';

export function centsToEuro(value: string): string {
  // mangopay values are in cents.
  let amount = `${parseInt(value) / 100}`;

  amount = parseFloat(amount).toFixed(2);

  return currency(amount);
}

export function currency(amount: string, currency: string = 'EUR') {
  const locale = LocalStorage.has('i18nextLng') 
    ? LocalStorage.get('i18nextLng') 
    : 'de-DE';

  return new Intl.NumberFormat(locale, { style: 'currency', currency })
    .format(parseFloat(amount));
}
